import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SectionHeading from '../components/SectionHeading';
import CtaBand from '../components/CtaBand';
import TipsterLogo from '../components/TipsterLogo';
import { useData } from '../context/DataContext';

const PRINCIPLES = [
  ['Selectivity', 'One release per tipster per day is a ceiling, not a target. If nothing qualifies, nothing is released and the day is recorded as “No pick”.'],
  ['Research', 'Statistics, form, tactical matchups, injuries and team news, scheduling and market conditions — all reviewed before a selection is released.'],
  ['Discipline', 'The same criteria apply on a quiet Tuesday and a packed Saturday. The process does not loosen to fill a slot.'],
  ['Transparency', 'Every tipster has a public archive with scores, odds and results — including the days they lose.']
];

export default function AboutPage() {
  const { tipsters } = useData();
  return (
    <>
      <Header />
      <section className="bg-white py-20 md:py-28">
        <div className="max-w-7xl mx-auto px-5 md:px-8 grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-7">
            <SectionHeading eyebrow="About" title="Three specialist tipsters under one roof — and one standard." lead="Top 3 Football Tipsters brings together three tipsters who work in different formats but share the same rule: research first, and never more than one release a day." />
            <div className="mt-10 space-y-5 text-slate-600 leading-relaxed text-base md:text-lg">
              <p>Turkish Team builds a Daily Double from goal and result markets. Asian Tips works exclusively in Asian Handicap lines. 24 BOX Tips releases one clean single at odds around 2.00. You choose the format that fits how you bet — or combine them.</p>
              <p>We do not promise profit. Football does not allow it and anyone who says otherwise is selling something else. What we promise is that every selection is researched, the criteria are consistent and the record is public.</p>
            </div>
          </div>
          <div className="lg:col-span-5">
            <div className="rounded-[28px] bg-navy text-white p-8 grain relative overflow-hidden lg:mt-12">
              <div className="eyebrow text-signal">The tipsters</div>
              <div className="mt-6 space-y-5">
                {tipsters.map(t => (
                  <div key={t.id} className="flex items-center gap-4">
                    <TipsterLogo tipster={t} className="w-12 h-12" />
                    <div><div className="font-display font-bold">{t.name}</div><div className="text-xs text-slate-300">{t.formatLabel}</div></div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 md:py-28 bg-mist border-y border-line">
        <div className="max-w-7xl mx-auto px-5 md:px-8">
          <SectionHeading eyebrow="Principles" title="What we hold ourselves to." />
          <div className="mt-12 grid md:grid-cols-2 gap-5">
            {PRINCIPLES.map(([t, d], i) => (
              <div key={t} className="card-lift rounded-3xl bg-white border border-line p-7 md:p-8" data-testid={`principle-${i}`}>
                <div className="font-mono text-xs text-royal">0{i + 1}</div>
                <h3 className="mt-3 font-display text-xl md:text-2xl font-bold text-navy">{t}</h3>
                <p className="mt-3 text-sm md:text-[15px] text-slate-600 leading-relaxed">{d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <CtaBand />
      <Footer />
    </>
  );
}
